type Props = {
  size: 'large' | 'small';
};

const MockToolCard = ({ size }: Props) => (
  <div
    className={`
  rounded-[12px] 
  bg-grey-gradient
  animate-shine-card
  bg-[length:600px]
  ${
    size === 'large'
      ? 'w-[225px] h-[225px] sm:w-[204px] sm:h-[204px] xs:w-[170px] xs:h-[170px] xxs:w-[225px] xxs:h-[225px]'
      : 'w-[200px] h-[200px] sm:w-[180px] sm:h-[180px] xs:w-[170px] xs:h-[170px]'
  }
  `}
  />
);

export { MockToolCard };
